import * as firebase from 'firebase/app';
import 'firebase/auth';
import { SIGN_IN_LINK_ERROR } from 'utils/constants/errors';
import {
  SET_PASSWORD_SUCCEEDED,
  SET_PASSWORD_FAILURE,
  INVALID_CODE,
  VALID_CODE,
  LOADING_STATE,
  REVERT_TO_OLD_EMAIL_SUCCEEDED,
  REVERT_TO_OLD_EMAIL_ERROR,
  GET_EMAILS_VALUES_SUCCEEDED,
  PASSWORD_RESET_CONFIRMATION_SENT,
  PASSWORD_RESET_CONFIRMATION_FAILED,
  EMAIL_VERIFICATION_SUCCEEDED,
  EMAIL_VERIFICATION_ERROR,
  SIGNIN_WITH_EMAIL_LINK_SUCCEEDED,
  SIGNIN_WITH_EMAIL_LINK_ERROR
} from './types';

// Set firebase user password
export const setNewPassword = (code, newPassword, type) => async dispatch => {
  try {
    const setPassword = firebase
      .functions()
      .httpsCallable(
        type === 'client' ? 'authClientSetPassword' : 'authTrainerSetPassword'
      );

    return setPassword({ invitationCode: code, newPassword })
      .then(() => dispatch({ type: SET_PASSWORD_SUCCEEDED }))
      .catch(err => {
        dispatch({ type: SET_PASSWORD_FAILURE });
      });
  } catch (err) {
    dispatch({ type: SET_PASSWORD_FAILURE, payload: `error: ${err}` });
  }
};

// Check invitation validatity
export const checkValidCode = (code, type) => async dispatch => {
  dispatch({ type: LOADING_STATE });
  try {
    const validInvite = firebase
      .functions()
      .httpsCallable(
        type === 'client' ? 'authClientCheckInvite' : 'authTrainerCheckInvite'
      );

    return validInvite({ invitationCode: code })
      .then(() => dispatch({ type: VALID_CODE }))

      .catch(err => {
        dispatch({
          type: INVALID_CODE
        });
      });
  } catch (err) {
    dispatch({ type: INVALID_CODE, payload: `error: ${err}` });
  }
};

// Set firebase user password
export const setPassword = (code, newPassword) => async dispatch => {
  try {
    return firebase
      .auth()
      .confirmPasswordReset(code, newPassword)
      .then(function() {
        dispatch({ type: SET_PASSWORD_SUCCEEDED });
      })
      .catch(function(err) {
        console.log(err);
        // Handle Errors here.
        dispatch({ type: SET_PASSWORD_FAILURE });
      });
  } catch (err) {
    dispatch({ type: SET_PASSWORD_FAILURE, payload: `error: ${err}` });
  }
};

// Check invitation validatity
export const validCode = code => async dispatch => {
  try {
    return firebase
      .auth()
      .verifyPasswordResetCode(code)
      .then(() => dispatch({ type: VALID_CODE }))
      .catch(function(err) {
        dispatch({ type: INVALID_CODE });
      });
  } catch (err) {
    dispatch({ type: INVALID_CODE, payload: `error: ${err}` });
  }
};

export const validateRecoverEmailCode = (
  actionCode,
  lang
) => async dispatch => {
  dispatch({ type: LOADING_STATE });
  // Confirm the action code is valid.
  firebase
    .auth()
    .checkActionCode(actionCode)
    .then(function(info) {
      // Get the restored email address.
      dispatch({
        type: GET_EMAILS_VALUES_SUCCEEDED,
        payload: {
          fromEmail: info.data.fromEmail,
          email: info.data.email
        }
      });
      // Revert to the old email.
      return firebase.auth().applyActionCode(actionCode);
    })
    .then(() => {
      dispatch({
        type: REVERT_TO_OLD_EMAIL_SUCCEEDED
      });
    })
    .catch(error => {
      // Invalid code.
      console.log(error);
      dispatch({
        type: REVERT_TO_OLD_EMAIL_ERROR,
        payload: error.message
      });
    });
};

export const resetClientPassword = restoredEmail => async dispatch => {
  dispatch({ type: LOADING_STATE });
  firebase
    .auth()
    .sendPasswordResetEmail(restoredEmail)
    .then(function() {
      // Password reset confirmation sent
      dispatch({
        type: PASSWORD_RESET_CONFIRMATION_SENT
      });
    })
    .catch(error => {
      // Error encountered while sending password reset code.
      console.log(error);
      dispatch({
        type: PASSWORD_RESET_CONFIRMATION_FAILED,
        payload: error
      });
    });
};

export const handleVerifyEmail = actionCode => async dispatch => {
  dispatch({ type: LOADING_STATE });
  firebase
    .auth()
    .applyActionCode(actionCode)
    .then(function(resp) {
      dispatch({
        type: EMAIL_VERIFICATION_SUCCEEDED
      });
    })
    .catch(function(error) {
      console.log(error);
      dispatch({
        type: EMAIL_VERIFICATION_ERROR,
        payload: `error: ${error}`
      });
    });
};

export const handleSignInWithEmailLink = actionCode => async dispatch => {
  dispatch({ type: LOADING_STATE });
  // Confirm the link is a sign-in with email link.
  if (firebase.auth().isSignInWithEmailLink(window.location.href)) {
    const getSignInLinkEmail = firebase
      .functions()
      .httpsCallable('authTrainerGetSignInLinkEmail');

    return getSignInLinkEmail({ signinLinkCode: actionCode })
      .then(Response => {
        if (Response.data.email) {
          firebase.auth().signInWithEmailLink(Response.data.email, window.location.href)
          .then(function() {
            dispatch({
              type: SIGNIN_WITH_EMAIL_LINK_SUCCEEDED
            })
          })
          .catch(function(error) {
            console.log("error", error);
            dispatch({
              type: SIGNIN_WITH_EMAIL_LINK_ERROR,
              payload: error
            })
          });
        } else {
          dispatch({
            type: SIGNIN_WITH_EMAIL_LINK_ERROR,
            payload: SIGN_IN_LINK_ERROR
          })
        }
      })
      .catch(error => {
        console.log("error", error);
        dispatch({
          type: SIGNIN_WITH_EMAIL_LINK_ERROR,
          payload: SIGN_IN_LINK_ERROR
        })
      });
  } else {
    dispatch({
      type: SIGNIN_WITH_EMAIL_LINK_ERROR,
      payload: SIGN_IN_LINK_ERROR
    })
  }
}
